import React from "react"
import { useTranslation } from "react-i18next"

export const EnergyMixKpi = (score) => {
  const { t } = useTranslation()

  if (score?.odd7_energy_mix_is_market_based) {
    return t(`score:score.13.chartEnergyMix.marketBased`)
  }

  return (
    score?.odd7_location_based_energy_mix_country_name ||
    t(`score:score.13.chartEnergyMix.locationBased`)
  )
}
